<template>
<div class="chapter">
<div class="inner_page">
<p class="C96"><a id="page_xi">ACKNOWLEDGMENTS</a></p><a id="page_xi">
<p class="C76">AS I WAS FINISHING THIS BOOK, I WAS STRUCK BY how many friends said to me, “Yeah, you were working on that when I met you.” It has been over a decade since I made the commitment to live with these stories. I’m grateful for the friends, relatives, students, and colleagues with whom I’ve studied and explored these tales, in conversation, in a private study group, and in classes at Emory University, the Michener Center for Writers at the University of Texas, Congregation Agudas Achim in Austin, and the Young Israel of Toco Hills. Their insights have deepened my appreciation and understanding of these texts. Arthur Kurzweil gave me the right words of encouragement at exactly the right time, and Andrea Cohen-Kiener, the book’s first reader, buoyed the project up with her enthusiasm, as did Reuven Travis. Karmi Ingber generously offered a comprehensive critique. (All errors in the texts, of course, are mine.) I’m grateful also to Robert H. Abzug, its second reader and its guardian angel, and to Jim Burr and Dave Hamrick at UT Press for taking a chance on a book that doesn’t easily fit into any publishing category. The Bill and Carol Fox Center for Humanistic Inquiry provided me with the time and the quiet in which to prepare the final drafts. Arianna Skibell, a generous and talented editor, is a constant source of inspiration for me, and I’m especially grateful to Barbara Freer Skibell, who has spent as many years living with these stories as I have. Her fine mind, her open heart, and her questing spirit inform every page.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Acknowledgments.vue?00c08312